import { useAuthContext } from '@core/shared';
import { useLocation, useNavigate, useParams } from '@online-webinar/router';
import { useEffect } from 'react';
import { isValidPreviousPath } from './isValidPreviousPath';

export const useAuthRedirect = () => {
    const { webinarId } = useParams({ strict: false });
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, managedAccounts } = useAuthContext();

    useEffect(() => {
        if (!isAuthenticated || !managedAccounts) return;

        const previousPath = location.state?.from;

        if (!isValidPreviousPath(previousPath) && !!webinarId) {
            navigate({ to: '/$webinarId', params: { webinarId: webinarId! }, state: location.state });
            return;
        }

        if (managedAccounts.length > 0) {
            navigate({ to: '/switch-account', state: location.state });
            return;
        }

        if (isValidPreviousPath(previousPath)) {
            navigate({ to: previousPath, state: location.state });
            return;
        }

        navigate({ to: '/' });
    }, [isAuthenticated, managedAccounts]);
};
